import { UnitsReference, UnitsMeasurement, UnitsReferenceEnum } from '@/modules/results/models/interwinnerResult';
import { ErrorInterwinnerFile } from '@/modules/results/models/errorInterwinnerFile';
import { ErrorRadionuclide } from '@/modules/results/models/errorRadionuclide';
import { ErrorEnum } from '@/models/errorEnum';

export function verifyUnitArrayConsistency(
  unitsReference: UnitsReference,
  currentUnits: UnitsMeasurement,
  fileName: string
): void {
  const referenceMeasurementsUnits = unitsReference.measurements;
  if (
    referenceMeasurementsUnits.activityUnit.length === 0 ||
    referenceMeasurementsUnits.uncertaintyValueUnit.length === 0 ||
    referenceMeasurementsUnits.decisionThresholdUnit.length === 0 ||
    referenceMeasurementsUnits.detectionLimitUnit.length === 0
  ) {
    referenceMeasurementsUnits.activityUnit = currentUnits.activityUnit;
    referenceMeasurementsUnits.uncertaintyValueUnit = currentUnits.uncertaintyValueUnit;
    referenceMeasurementsUnits.decisionThresholdUnit = currentUnits.decisionThresholdUnit;
    referenceMeasurementsUnits.detectionLimitUnit = currentUnits.detectionLimitUnit;
  } else if (
    referenceMeasurementsUnits.activityUnit !== currentUnits.activityUnit ||
    referenceMeasurementsUnits.uncertaintyValueUnit !== currentUnits.uncertaintyValueUnit ||
    referenceMeasurementsUnits.decisionThresholdUnit !== currentUnits.decisionThresholdUnit ||
    referenceMeasurementsUnits.detectionLimitUnit !== currentUnits.detectionLimitUnit
  ) {
    throw new ErrorInterwinnerFile(
      ErrorEnum.INVALID_UNIT_CONSISTENCY,
      fileName,
      unitsReference.fileName,
      UnitsReferenceEnum.MEASUREMENTS
    );
  }
}

export function verifyUnitMetadataConsistency(
  unitsReference: UnitsReference,
  unitMetadata: string,
  unitMetadataEnum: UnitsReferenceEnum,
  fileName: string
): void {
  if (unitsReference.metadata[unitMetadataEnum].length === 0) {
    unitsReference.metadata[unitMetadataEnum] = unitMetadata;
  } else if (unitsReference.metadata[unitMetadataEnum] !== unitMetadata) {
    throw new ErrorInterwinnerFile(
      ErrorEnum.INVALID_UNIT_CONSISTENCY,
      fileName,
      unitsReference.fileName,
      unitMetadataEnum
    );
  }
}

export function verifyRnListOrder(rnListOrder: string[], radionuclides: Set<string>): void {
  const radionuclidesArr = Array.from(radionuclides);

  for (const rn of rnListOrder) {
    if (!radionuclidesArr.includes(rn)) {
      throw new ErrorRadionuclide(ErrorEnum.RADIONUCLIDE_NOT_FOUND, rn);
    }
  }
}
